import { EventPermissions, SubscriptionStatus, UserBadge } from "../types/graphql";

const STAFF_PERMISSIONS: EventPermissions[] = [
  EventPermissions.HeyLadyAdmin,
  EventPermissions.HeyLadyTeam,
  EventPermissions.BigSister,
];

/**
 * Shared restricted-access check used by ProtectedLayout and membership settings.
 * Inactive members, and members without an active plan (except staff / prevent-redirect),
 * are restricted to the membership settings surface.
 */
export const isMembershipRestricted = ({
  kind,
  activePlan,
  preventRedirect = false,
}: {
  kind?: EventPermissions | null;
  activePlan?: string | null;
  preventRedirect?: boolean;
}): boolean => {
  const isStaff = kind ? STAFF_PERMISSIONS.includes(kind) : false;
  return kind === EventPermissions.InactiveMember || (!activePlan && !(preventRedirect || isStaff));
};

export const isGuestUser = (user?: { badge?: UserBadge | null } | null): boolean =>
  user?.badge === UserBadge.Guest;

/**
 * A paid, activated membership. A trial is not, so a trial member keeps the
 * three-events lock; activation lifts it.
 */
export const hasActivePaidSubscription = (status?: SubscriptionStatus | null): boolean =>
  status === SubscriptionStatus.Active || status === SubscriptionStatus.NonRenewing;
